import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { Angular2SignaturePadModule } from "../../components/angular2-signaturepad/angular2-signaturepad.module";
import { GyzmoButtonModule } from "../../components/gyzmo-button/gyzmo-button.module";
import { ViewModal } from "./view.modal";

@NgModule(
    {
        declarations: [
            ViewModal,
        ],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            TranslateModule,
            GyzmoButtonModule,
            Angular2SignaturePadModule,
        ],
        providers: [],
    })

export class ViewModalModule {
}
